<div class="container">
  <ion-input
    (ionFocus)="onInputFocus()"
    (input)="onInputChange($event.target.value)"
    [(ngModel)]="searchText"
    [disabled]="selectedAgent"
    [placeholder]="selectedAgent ? '' : placeholderText"
    [style.backgroundColor]="selectedAgent && 'transparent'"
    class="text-input"
    type="email"
    autocapitalize="off"
    autocorrect="off"
    spellcheck="false"
  >
    <!-- When there is an agent selected we disable icons and interaction, only one can be selected at a time -->
    <ion-icon *ngIf="!selectedAgent" slot="start" name="search-outline" />

    @if (!selectedAgent && searchText) {
      <ion-icon
        slot="end"
        (click)="clearSearch($event)"
        name="close-circle"
      />
    }

    <ion-chip *ngIf="selectedAgent">
      <avatar
        class="avatar"
        [imageURL]="selectedAgentProfileImageURL"
        [avatarName]="selectedAgentInitials"
      />
      <ion-label>{{ selectedAgent.username }}</ion-label>
      <ion-icon
        class="agent-preview"
        (click)="removeSelectedAgent()"
        name="close-circle"
      />
    </ion-chip>
  </ion-input>
</div>

@if (hits.length !== 0) {
  <div class="hits">
    <div class="hit link" *ngFor="let hit of hits">
      <div (click)="resultClicked(hit)">
        <app-public-profile-item 
          [pairedAgentData]="hit"
          [searchInviteMode]="false"
          [showControls]="false"
          [showInvite]="false"
          [showContact]="false"
          [showSocial]="false"
        />
      </div>
    </div>
  </div>
}

<div *ngIf="displayNoResultsLabel()" class="no-results-label">
  {{ noResultsMessage }}
</div>
